export function importAndSortCourseImages() {
  // 1. Grab all image files in that folder
  const context = require.context(
    "../assets/courses",
    false,
    /\.(jpe?g|png|webp)$/
  );

  return context
    .keys()
    .map((key) => {
      const src = context(key).default || context(key);
      const fileName = key.replace("./", ""); // e.g. "foo_3.jpg"

      // extract the number after the last underscore
      const match = fileName.match(/_(\d+)\.(jpe?g|png|webp)$/i);
      const index = match ? parseInt(match[1], 10) : Infinity;

      return { src, index };
    })
    .sort((a, b) => a.index - b.index) // sort by that trailing number
    .map((img) => img.src); // [ "…/assets/courses/bar_1.png", "…/foo_3.jpg", … ]
}
